import {
  generatePath,
  Navigate,
  useLocation,
  useParams,
} from 'react-router-dom'
import { getEnvVar } from 'utils/env'

interface NavigateWithParamsProps {
  to: string
  replace?: boolean
}

const NavigateWithParams = ({ to, ...props }: NavigateWithParamsProps) => {
  const params = useParams()
  const { search: currentSearch } = useLocation()

  // 1. Separate path from search params
  const [targetPath, targetSearch = ''] = to.split('?')

  // 2. Merge Search Params
  const merged = new URLSearchParams(currentSearch)
  new URLSearchParams(targetSearch).forEach((value, key) => {
    merged.set(key, value)
  })
  const mergedSearch = merged.toString()

  // 3. Safe Path Generation
  let finalPathname = targetPath

  try {
    // This will throw if targetPath has a :param that isn't in 'params'
    finalPathname = generatePath(targetPath, params)
  } catch (error) {
    if (getEnvVar('APP_ENV') === 'development') {
      console.warn(
        `NavigateWithParams: Failed to resolve path "${targetPath}". ` +
          `Check if the route parameters match the current context.`,
        error,
      )
    }
    // Fallback: If it fails, finalPathname stays as the original targetPath string
  }

  const destination = mergedSearch
    ? `${finalPathname}?${mergedSearch}`
    : finalPathname

  return <Navigate {...props} to={destination} />
}

export default NavigateWithParams
